import React, { Component } from 'react';
import { inject } from 'mobx-react';

@inject('routesStore')
export default class TabRoute extends Component {

    componentWillMount() {

        this.props.routesStore.setSelectedTabId(this.props.routeId);
    }

    render() {
        
        const Component = this.props.component;

        return <Component {...this.props} />
    }
}